<template>
  <v-dialog
    v-model="show.show"
    width="500"
  >
    <v-card>
      <v-card-title>{{show.text}}</v-card-title>
      <v-card-actions class="justify-end">
        <v-btn
          color="blue"
          text
          @click="show.action(show.actionData)"
        >
          Да
        </v-btn>
        <v-btn
          color="blue"
          text
          @click="$emit('cancel')"
        >
          Нет
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
    import Vue from "vue";

    export default Vue.extend({
        name: "ActionConfirmation",
        props: {
            show: {
                required: true,
                type: Object
            }
        }
    })
</script>

<style scoped>

</style>
